import { Link } from "react-router-dom";
import { Phone, Camera, Clock } from "lucide-react";
import { BUSINESS } from "@/lib/constants";
import { track, EVENTS } from "@/lib/analytics";

/**
 * Final CTA block — yellow primary "Call" + cyan-bordered "Upload Photos /
 * Free Estimate". Mirrors the original site's Get-In-Touch + Final-CTA
 * sections. Tones supported: 'default' (dark base) and 'alt' (slightly lifted).
 */
export default function CTABlock({
    eyebrow = "Free Estimate · No Obligation",
    headline = "Ready for a Free Estimate?",
    body = "Call, text, or send a photo of your enclosure. We'll give you a same-week reply when our schedule allows.",
    tone = "default",
    showHours = true,
}) {
    const alt = tone === "alt";
    return (
        <section
            className={`a1-section ${alt ? "a1-bg-alt" : "a1-bg-base"}`}
            data-testid="cta-block"
        >
            <div className="a1-container text-center">
                <p className="a1-eyebrow mb-4 justify-center" style={{ display: "inline-flex" }}>
                    {eyebrow}
                </p>
                <h2 className="mb-5 max-w-3xl mx-auto a1-h2-underline">
                    {headline}
                </h2>
                <p
                    className="max-w-2xl mx-auto mb-8 text-[16px] md:text-[17px] leading-relaxed"
                    style={{ color: "var(--color-text-muted)" }}
                >
                    {body}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <a
                        href={`tel:${BUSINESS.phoneTel}`}
                        onClick={() => track(EVENTS.PHONE_CLICK, { placement: "cta-block" })}
                        className="a1-btn-primary"
                        data-testid="ctablock-call"
                    >
                        <Phone size={18} strokeWidth={2.5} /> Call {BUSINESS.phone}
                    </a>
                    <Link
                        to="/upload-photos"
                        className="a1-btn-secondary"
                        data-testid="ctablock-photo"
                    >
                        <Camera size={18} /> Upload Photos
                    </Link>
                </div>
                {showHours ? (
                    <p
                        className="text-sm mt-6 inline-flex items-center gap-1.5 uppercase tracking-wider font-semibold"
                        style={{ color: "var(--color-text-dim)" }}
                    >
                        <Clock size={14} /> {BUSINESS.hours}
                    </p>
                ) : null}
            </div>
        </section>
    );
}
